module.exports = __webpack_public_path__ + "static/media/success2@3x.05a36e71.png";